<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">

    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img src="assets/images/BeExpert-logo (3).svg" alt="BeExpert" class="auth-logo-img" />
        </a>

        <div class="auth-step-pill">Step 2 of 2 — Verify your login</div>

        <h1 class="auth-left-h1">You're almost in.<br>Just one more<br>quick step.</h1>
        <p class="auth-left-sub">
          We've sent a 6-digit OTP to your registered mobile number.
          Enter it below to access your account.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          OTP sent via SMS to your number
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Valid for 2 minutes
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Your number is never shared with anyone
        </div>

        <div class="auth-ill-cards">
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
            <i class="bi bi-envelope-paper"></i>
			</div>
            <div>
              <span class="auth-ill-title">SMS Sent</span>
              <span class="auth-ill-sub">Your OTP: ● ● ● ● ● ●  · Just now</span>
            </div>
          </div>
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
				<i class="bi bi-graph-up-arrow"></i>
			</div>
            <div>
              <span class="auth-ill-title">Resume your journey</span>
              <span class="auth-ill-sub">Your roadmap &amp; progress are waiting</span>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-stats-bar">
        <div class="auth-stat-col">
          <span class="auth-stat-num">10K+</span>
          <span class="auth-stat-lbl">Active students</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">Free</span>
          <span class="auth-stat-lbl">To get started</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">5 min</span>
          <span class="auth-stat-lbl">To your score</span>
        </div>
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert" />
                <span class="mt-1 beexpert">BeExpert</span>
      </a>
      <div class="auth-form-box">

        <div class="auth-form-title">Enter OTP</div>
        <div class="auth-form-sub">
          6-digit code sent via SMS to
          <strong>+91 {{ userPhone }}</strong>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">

          <div class="auth-field">
            <label class="auth-label">Enter 6-digit OTP</label>
            <div class="otp-row" formArrayName="otp">
              <input
                *ngFor="let ctrl of otpControls.controls; let i = index"
                [formControlName]="i"
                class="otp-box"
                maxlength="1"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                #otpInput
                (input)="onOtpInput($event, i)"
                (keydown)="onOtpKeyDown($event, i)"
                (paste)="onOtpPaste($event)"
              />
            </div>
          </div>

          <p class="auth-resend">
            Didn't receive it?
            <ng-container *ngIf="!canResendOtp">
              <span class="auth-resend__timer">Resend OTP in {{ displayTime }}</span>
            </ng-container>
            <ng-container *ngIf="canResendOtp">
              <span class="auth-resend__link" (click)="resendOtp()">Resend OTP</span>
            </ng-container>
          </p>

          <button
            type="submit"
            class="auth-submit"
            [disabled]="!isOtpValid()"
          >
            Verify &amp; Sign In →
          </button>

        </form>

        <div class="change-num" (click)="goToPhonePage()">← Change mobile number</div>

        <div class="security-note">
          <span style="font-size:18px">
			<i class="bi bi-lock"></i>
		  </span>
          <div class="security-note-text">
            Your phone number is used only for login. We'll never share it with third parties.
          </div>
        </div>

      </div>
    </div>

  </div>
</ng-template>
